var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.909 19.412h-2.502c-.067-.253-.097-7.542-.033-8.035.787-.042 1.579-.015 2.421-.013v1l.063.009c.041-.047.085-.092.122-.137a2.73 2.73 0 012.002-1.062 3.61 3.61 0 011.74.25c.524.215.947.62 1.182 1.134.277.611.413 1.277.4 1.948.013 1.546.009 3.091.012 4.636 0 .085-.017.17-.028.274h-2.502c-.01-.147-.026-.295-.026-.443 0-1.327 0-2.653-.019-3.974a3.12 3.12 0 00-.148-.867 1.006 1.006 0 00-.83-.711 1.861 1.861 0 00-.91.046 1.111 1.111 0 00-.802.839c-.082.33-.128.666-.136 1.006-.016 1.25 0 2.499 0 3.748l-.006.352zM11.729 19.408H9.263c-.08-.237-.118-7.448-.039-8.037.822-.036 1.644-.012 2.466 0 .073.269.111 7.371.039 8.037zM10.46 7.354a1.477 1.477 0 011.484 1.448 1.498 1.498 0 01-1.507 1.472 1.46 1.46 0 11.018-2.92h.005z",
    fill: "#fff"
  })));
}
export default SvgLinkedIn;